import http from "../http-common";

class PisService {
  accept() {
    return http.post("patient/app-settings/accept-pis", {});
  }
}

const dataservice = new PisService();

export default dataservice;
